import { LessonPlan } from '@lessonup/typescript-core/domain';
import { sanitizeContent } from '@lessonup/typescript-core/utils';
import React from 'react';
import './css/LessonPlanHeader.less';

type Props = {
  child: LessonPlan.Children.Header;
};

const LessonPlanHeader: React.FC<Props> = ({ child }) => {
  const html = sanitizeContent(child.text);
  return (
    <div className="plan-child lesson-plan-header" data-child-type="header">
      <div className="header">
        <h2 dangerouslySetInnerHTML={{ __html: html }}></h2>
      </div>
    </div>
  );
};

export default LessonPlanHeader;
